import { FaY } from "react-icons/fa6";
import { get, post,del, patch, postMultipart, patchMultipart } from "./api_helper";
import * as url from "./url_helper";

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};



// get jobs
export const apiGetOurWork = () => get(url.API_OUR_WORK);

//get Work detail
export const apiGetOurWorkDetail = (id) => get(`${url.API_OUR_WORK}/${id}`);
// get what we do
export const apiGetWhatWeDo= () => get(url.API_WHAT_WE_DO);

// get what we do
export const apiGetWhatWeDoDetails= (id) => get(`${url.API_WHAT_WE_DO}/${id}`);

//get Our Team
export const apiGetTeamData = () => get(url.API_OUR_TEAM);

//get Office(About Us)
export const apiGetOffices = () => get(url.API_OFFICES);

// get HowWeDo APi
export const apiGetHowWeDo = () => get(url.API_HOW_WE_DO);

//get Config Data API
export const apiGetConfig = () => get(url.API_CONFIG);

//get Blog Listing
export const apiGetBlog = () => get(url.API_BLOG);

//get Blog Details
export const apiGetBlogDetails = (id) => get(`${url.API_BLOG}/${id}`);

// get Podcast Listing
export const apiGetPodcast = () => get(url.API_PODCAST);

// get Partner Listing
export const apiGetPartners = () => get(url.API_PARTNER);

//get Influencer Details
export const apiGetInfluencerDetails = () => get(url.API_INFLUENCER);

//get Our Clients Listing
export const apiGetOurClients = () => get(url.API_CLIENT);